import ApplicationTab from "@/models/ApplicationTab";

const tabs = {
    /** main tab within the list of orders  */
    orders: new ApplicationTab({name: 'Заказ-наряды', view: 'orders'}),
    orderAdd: new ApplicationTab({name: 'Новый заказ-наряд', view: 'orderadd'}),
    orderView: new ApplicationTab({name: 'Заказ-наряд', view: 'order'}),

    /** list of vehicles tab */
    vehicles: new ApplicationTab({ name: 'Автомобили', view: 'Vehicles'}),
    vehicleAdd: new ApplicationTab({ name: 'Новый автомобиль', view: 'Vehicle' }),
    vehicleView: new ApplicationTab({ name: 'Редактировать автомобиль', view: 'Vehicle', allowMultiple: true }),

    /** list of vehicles models tab  */
    vehicleModels:  new ApplicationTab({ name: 'Модели автомобилей', view: 'vehiclemodels' }),
    vehicleModelView:  new ApplicationTab({ name: 'Новая модель автомобиля', view: 'vehiclemodel', allowMultiple: true }),

    /** list of vehicle manufacturers */
    vehicleManufacturers: new ApplicationTab({ name: 'Марки автомобилей', view: 'vehiclemanufacturers'}),
    vehicleManufacturerView: new ApplicationTab({ name: 'Новая марка автомобилей', view: 'vehiclemanufacturer', allowMultiple: true}),
    
    /** list of users */
    users: new ApplicationTab({ name: 'Пользователи', view: 'users'}),    
    userAdd: new ApplicationTab({ name: 'Новый пользователь', view: 'user', params: [null, true] }),
    userView: new ApplicationTab({ name: 'Карточка пользователя', view: 'user', allowMultiple: true }),  

    /** list of items */
    items: new ApplicationTab({ name: 'Запчасти', view: 'items', params: [false] }),
    itemAdd: new ApplicationTab({ name: 'Новая запчасть', view: 'item', params: [null, true] }),
    itemView: new ApplicationTab({ name: 'Запчасть', view: 'item', allowMultiple: true, params: [null, false] }),

    /** list of items groups */
    itemsGroups: new ApplicationTab({ name: 'Группы запчастей', view: 'itemsGroups', params: [false] }),
    itemsGroup: new ApplicationTab({ name: 'Карточка группы запчастей', view: 'itemsGroup', params: [null, true] }),

    /** list of employees */
    employees: new ApplicationTab({ name: 'Сотрудники', view: 'employees'}),
    employeeAdd: new ApplicationTab({ name: 'Новый cотрудник', view: 'employee', params: [null, true]}),
    employeeView: new ApplicationTab({ name: 'Карточка сотрудника', view: 'employee', allowMultiple: true}),

    /** list of service-jobs */
    jobs: new ApplicationTab({ name: 'Сервисные работы', view: 'jobs'}),
    jobAdd: new ApplicationTab({ name: 'Новая сервисная работа', view: 'job'}),
    jobView: new ApplicationTab({ name: 'Сервисная работа', view: 'job', allowMultiple: true }),

    /** list of service-job-operations */
    jobOperations: new ApplicationTab({ name: 'Сервисные операции', view: 'jobOperations'}),
    jobOperationAdd: new ApplicationTab({ name: 'Новая сервисная операция', view: 'jobOperationAdd'}),
    jobOperationView: new ApplicationTab({ name: 'Cервисная операция', view: 'jobOperationView', allowMultiple: true }),

    /** list of service-job-components */
    jobComponents: new ApplicationTab({ name: 'Сервисные компоненты', view: 'jobComponents'}),
    jobComponentAdd: new ApplicationTab({ name: 'Новый сервисный компонент', view: 'jobComponentAdd'}),
    jobComponentView: new ApplicationTab({ name: 'Сервисный компонент', view: 'jobComponentView', allowMultiple: true }),

    /** list of service-job-components-groups */
    jobComponentGroups: new ApplicationTab({ name: 'Группы сервисных компонентов', view: 'jobComponentGroups'}),
    jobComponentGroupAdd: new ApplicationTab({ name: 'Новая группа сервисных компонентов', view: 'jobComponentGroupAdd'}),
    jobComponentGroupView: new ApplicationTab({ name: 'Группа сервисных компонентов', view: 'jobComponentGroupView', allowMultiple: true }),

    /** list of service-job-categories */
    jobCategories: new ApplicationTab({ name: 'Категории сервисных работ', view: 'jobCategories'}),
    jobCategoryAdd: new ApplicationTab({ name: 'Новая категория сервисных работ', view: 'jobCategoryAdd'}),
    jobCategoryView: new ApplicationTab({ name: 'Категория сервисных работ', view: 'jobCategoryView', allowMultiple: true }),

    /** list of service-job-groups */
    jobGroups: new ApplicationTab({ name: 'Группы сервисных работ', view: 'jobGroups'}),
    jobGroupAdd: new ApplicationTab({ name: 'Новая группа сервисных работ', view: 'jobGroupAdd'}),
    jobGroupView: new ApplicationTab({ name: 'Группа сервисных работ', view: 'jobGroupView', allowMultiple: true }),

    /** list of counterparties */
    counterparties: new ApplicationTab({ name: 'Контрагенты', view: 'counterpatries'}),
    counterparty: new ApplicationTab({ name: 'Карточка контрагента', view: 'counterparty', allowMultiple: true }),

    /** work schedule timeline */
    schedule: new ApplicationTab({ name: 'График загрузки', view: 'schedule'})
};

export default tabs;